import { IComment, ICommentContent } from "interfaces/comment";
import { useContext } from "react";
import { AxiosContext } from "contexts/AxiosContext";
import { AxiosResponse } from "axios";

interface Result {
  createComment: (content: ICommentContent) => Promise<IComment>;
  updateComment: (
    commentId: number,
    content: ICommentContent
  ) => Promise<IComment>;
  deleteComment: (commentId: number) => Promise<void>;
}

export function useWriteComment(
  pathPrefix: string,
  onCommentsChanged: () => void
): Result {
  const { axios } = useContext(AxiosContext)!;

  const headers = {
    "Content-Type": "application/json",
    Accept: "application/json"
  };

  return {
    createComment: async (content: ICommentContent): Promise<IComment> => {
      const { data } = await axios.post<
        ICommentContent,
        AxiosResponse<IComment>
      >(`${pathPrefix}/comments`, content, { headers });
      onCommentsChanged();
      return data;
    },
    updateComment: async (
      commentId: number,
      content: ICommentContent
    ): Promise<IComment> => {
      const { data } = await axios.put<
        ICommentContent,
        AxiosResponse<IComment>
      >(`${pathPrefix}/comments/${commentId}`, content, { headers });
      onCommentsChanged();
      return data;
    },
    deleteComment: async (commentId: number): Promise<void> => {
      await axios.delete<void, void>(`${pathPrefix}/comments/${commentId}`);
      onCommentsChanged();
    }
  };
}
